module.exports = __webpack_public_path__ + "img/phone-results.02f4f11.png";